export default "__VITE_ASSET__BKOCjnLW__"